exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._36c7wmZGDPc3oh6cpvmWrm{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir] ._36c7wmZGDPc3oh6cpvmWrm{background-color:\"[theme:neutralLighter, default:#f3f2f1]\";border-bottom:1px solid \"[theme:neutralLight, default:#edebe9]\"}._36c7wmZGDPc3oh6cpvmWrm._3C_noF_EnUjEK2IS6j5XoT{height:76px}._36c7wmZGDPc3oh6cpvmWrm._2hCoEgNIbhBN2HeKbwTtq8{height:126px}", ""]);
// Exports
exports.locals = {
	"ribbon": "_36c7wmZGDPc3oh6cpvmWrm",
	"ribbonBarSingleLine": "_3C_noF_EnUjEK2IS6j5XoT",
	"ribbonBarMultiline": "_2hCoEgNIbhBN2HeKbwTtq8"
};